import { render, staticRenderFns } from "./FullMenu.vue?vue&type=template&id=485b05f0&"
import script from "./FullMenu.vue?vue&type=script&lang=js&"
export * from "./FullMenu.vue?vue&type=script&lang=js&"
import style0 from "./FullMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports